import StatisticsCard from "./StatisticsCard";

export default function SocialMedia({ data }) {
    return (<div className="row">
        <div className="col-xl-12 mb-4 col-lg-12 col-12">
            <h5 className="card-title fs-15 mb-1">
                Social Media Visibility
            </h5>
            <div className="row-cols-2 row-cols-xl-5 mt-2 row">
                <StatisticsCard title={"Facebook"} value={data ? data.facebookVisits : 0} imgUrl={"https://img.icons8.com/?size=25&id=118497&format=png&color=000000"}
                    className="col mb-20px" />
                <StatisticsCard title={"Instagram"} value={data ? data.instagramVisits : 0} imgUrl={"https://img.icons8.com/?size=25&id=Xy10Jcu1L2Su&format=png&color=000000"}
                    className="col mb-20px" />
                <StatisticsCard title={"Youtube"} value={data ? data.youtubeVisits : 0} imgUrl={"https://img.icons8.com/?size=25&id=19318&format=png&color=000000"}
                    className="col mb-20px" />
                <StatisticsCard title={"Twitter"} value={data ? data.twitterVisits : 0} imgUrl={"https://img.icons8.com/?size=25&id=ClbD5JTFM7FA&format=png&color=000000"}
                    className="col mb-20px" />
                <StatisticsCard title={"Whatsapp"} value={data ? data.whatsappVisits : 0} imgUrl={"https://img.icons8.com/?size=25&id=16713&format=png&color=000000"}
                    className="col mb-20px" />
            </div>
        </div>
    </div>
    )
}